<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import floppyDisk from "../../../../static/assets/images/floppy-disk.svg";
export default {
  name: "MusicTab",
  data() {
    return {
      floppyDisk,
      apple_link: false,
      spotify_link: false,
      not_required_music: true,
    };
  },
  components: {},
  computed: {
    ...mapGetters({
      musicTabErrors: "warmups/musicTabErrors",
    }),
    currentActivity() {
      return this.$store.getters[`${this.currentType}/currentActivity`];
    },
    musicTabErrors() {
      return this.$store.getters[`${this.currentType}/musicTabErrors`];
    },
    currentType() {
      const url = this.$route.path.split("/")[1];
      if (this.$route) {
        if (url == "update-warmup" || this.$route.path == "/create-warmup") {
          return "warmups";
        } else if (
          url == "update-stretch-flow" ||
          this.$route.path == "/create-stretch-flow"
        ) {
          return "stretchflows";
        }
      }
      return "workouts";
    },
    spotify_playlist_name: {
      set(value) {
        this.$store.commit(`${this.currentType}/setActivityField`, {
          fieldName: "spotify_playlist_name",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.spotify_playlist_name;
        }
        return "";
      },
    },
    spotify_playlist_name_state() {
      return this.currentActivity.spotify_playlist_name ? true : false;
    },
    spotify_playlist_name_errors() {
      if (
        this.musicTabErrors &&
        this.musicTabErrors.spotify_playlist_name != null
      ) {
        return this.musicTabErrors.spotify_playlist_name.join("<br/>");
      }
      return "";
    },
    spotify_playlist_link: {
      set(value) {
        this.$store.commit(`${this.currentType}/setActivityField`, {
          fieldName: "spotify_playlist_link",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.spotify_playlist_link;
        }
        return "";
      },
    },
    apple_playlist_name_state() {
      return this.currentActivity.apple_playlist_name ? true : false;
    },
    apple_playlist_name: {
      set(value) {
        this.$store.commit(`${this.currentType}/setActivityField`, {
          fieldName: "apple_playlist_name",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.apple_playlist_name;
        }
        return "";
      },
    },
    apple_playlist_link: {
      set(value) {
        this.$store.commit(`${this.currentType}/setActivityField`, {
          fieldName: "apple_playlist_link",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.apple_playlist_link;
        }
        return "";
      },
    },
    music_notes: {
      set(value) {
        this.$store.commit(`${this.currentType}/setActivityField`, {
          fieldName: "music_notes",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.music_notes;
        }
        return "";
      },
    },
    required_music: {
      set(value) {
        this.$store.commit(`${this.currentType}/setActivityField`, {
          fieldName: "required_music",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          if (this.currentActivity.required_music) {
            this.not_required_music = false;
          }
          return this.currentActivity.required_music;
        }
        return "";
      },
    },
  },
  methods: {
    updateActivity() {
      this.$store.commit("commons/setPreloader", true);
      this.spotify_link = false;
      this.apple_link = false;
      var savingMusic1 = true;
      var savingMusic2 = true;

      if (this.currentActivity.apple_playlist_link != "") {
        savingMusic1 = this.appleLinkValidation();
      }
      if (this.currentActivity.spotify_playlist_link != "") {
        savingMusic2 = this.spotifyLinkValidation();
      }

      if (savingMusic1 && savingMusic2) {
        this.$store
          .dispatch(`${this.currentType}/updateActivity`, this.$route.params.id)
          .then(
            () => {
              this.$store.commit(`commons/setSavingForm`, "Saved");
              this.tabStatus(false);
              this.$store.commit("commons/setPreloader", false);
            },
            (error) => {
              console.log(error);
            }
          );
      } else {
        this.$store.commit("commons/setPreloader", false);
      }
    },

    appleLinkValidation() {
      const apple = "music.apple.com";
      if (!this.currentActivity.apple_playlist_link.includes(apple)) {
        this.$store.commit(
          `commons/setSavingErrorMessage`,
          "Invalid apple playlist link"
        );
        this.apple_link = true;
        return false;
      }
      return true;
    },
    spotifyLinkValidation() {
      const android = "open.spotify.com/playlist";
      if (!this.currentActivity.spotify_playlist_link.includes(android)) {
        this.$store.commit(
          `commons/setSavingErrorMessage`,
          "Invalid spotify playlist link"
        );
        this.spotify_link = true;
        return false;
      }
      return true;
    },

    tabStatus(status) {
      this.$store.commit(`warmups/setTabStatus`, status);
    },
    requiredMusicStatus() {
      if (this.required_music) {
        this.required_music = false;
        this.not_required_music = true;
      } else {
        this.required_music = true;
        this.not_required_music = false;
      }
    },
  },
  watch: {
    spotify_playlist_name() {
      this.tabStatus(true);
    },
    spotify_playlist_link() {
      this.tabStatus(true);
    },
    apple_playlist_name() {
      this.tabStatus(true);
    },
    apple_playlist_link() {
      this.tabStatus(true);
    },
    music_notes() {
      this.tabStatus(true);
    },
    required_music() {
      this.tabStatus(true);
    },
  },
};
</script>

<template>
  <div class="py-5 px-5">
    <div class="container">
      <b-form>
        <div class="row">
          <div class="col-md-6">
            <b-form-group>
              <label label-for="spotify_playlist_name d-inline"
                >SPOTIFY PLAYLIST NAME
                <a
                  v-if="spotify_playlist_link"
                  :href="spotify_playlist_link"
                  target="_blank"
                  ><b-icon icon="caret-right-square-fill"
                /></a>
              </label>
              <b-form-input
                v-model="spotify_playlist_name"
                id="spotify_playlist_name"
                placeholder="Eg: Latin Dance Cardio"
                :state="spotify_playlist_name_state"
                v-if="required_music"
              ></b-form-input>
              <b-form-input
                v-model="spotify_playlist_name"
                id="spotify_playlist_name"
                placeholder="Eg: Latin Dance Cardio"
                v-if="!required_music"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label="SPOTIFY PLAYLIST LINK"
              label-for="spotify_playlist_link"
            >
              <b-form-input
                v-model="spotify_playlist_link"
                id="spotify_playlist_link"
                placeholder="Eg: https://play.spotify.com/user/spotify_latino/playlist/2vobha…"
                :class="spotify_link ? 'is-invalid' : ''"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group>
              <label label-for="apple_playlist_name d-inline"
                >APPLE PLAYLIST NAME
                <a
                  v-if="apple_playlist_link"
                  :href="apple_playlist_link"
                  target="_blank"
                  ><b-icon icon="caret-right-square-fill"
                /></a>
              </label>

              <b-form-input
                v-model="apple_playlist_name"
                id="apple_playlist_name"
                placeholder="Eg: Latin Dance Cardio"
                :state="apple_playlist_name_state"
                v-if="required_music"
              ></b-form-input>
              <b-form-input
                v-model="apple_playlist_name"
                id="apple_playlist_name"
                placeholder="Eg: Latin Dance Cardio"
                v-if="!required_music"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              label="APPLE PLAYLIST LINK"
              label-for="apple_playlist_link"
            >
              <b-form-input
                v-model="apple_playlist_link"
                id="apple_playlist_link"
                placeholder="Eg: https://music.apple.com/au/playlist/2vobha…"
                :class="apple_link ? 'is-invalid' : ''"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-12">
            <b-form-group label="Notes" label-for="notes">
              <b-form-textarea
                v-model="music_notes"
                id="notes"
                placeholder="Notes"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
          </div>
          <div class="col-12">
            <b-form-group label="" label-for="">
              <b-form-checkbox
                switch
                class="mr-3"
                @change="requiredMusicStatus"
                :checked="not_required_music"
              >
                NO PLAYLISTS REQUIRED
              </b-form-checkbox>
            </b-form-group>
          </div>
        </div>
      </b-form>
    </div>

    <button
      class="floating-btn btn no-outline"
      @click="updateActivity()"
      :disabled="
        (!apple_playlist_name_state && required_music) ||
        (!spotify_playlist_name_state && required_music)
      "
    >
      <span class="d-flex justify-content-center align-items-center">
        <img :src="floppyDisk" />
      </span>
    </button>
  </div>
</template>
